module.exports = __webpack_public_path__ + "static/media/bancdepoissons.a14f36a7.glb";